<template>

        <div class="rounded center">
            <h2>
                <i :class="icon"></i>
            </h2>
        </div>

</template>

<script>
export default {
    props: ['icon', 'text']
}
</script>

<style scoped>

    .rounded{
        margin: 20px auto;
        border-radius: 50%;
        border: 3px solid #263238;
        height: 20vh;
        width: 20vh;
    }

    .benefit{
        position: relative;
        bottom: 18px;
    }

</style>
